import moment from 'moment';

const NotificationHistoryColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    sorter: (a, b) => a.index - b.index,
    width: 100
  },
  {
    title: 'Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    width: 200
  },
  {
    title: 'Email',
    dataIndex: 'email',
    slot: 'email',
    sorter: (a, b) => a.email.localeCompare(b.email),
    width: 200
  },
  {
    title: 'Contact Number',
    dataIndex: 'sms',
    width: 200
  },
  {
    title: 'Webpage URL',
    dataIndex: 'url',
    slot: 'url',
    sorter: (a, b) => a.url.localeCompare(b.url),
    width: 200
  },
  {
    title: 'Notification Type',
    dataIndex: 'notification_type_name',
    slot: 'notification_type_name',
    sorter: (a, b) => a.notification_type_name.localeCompare(b.notification_type_name),
    width: 200
  },
  {
    title: 'Date Sent',
    dataIndex: 'date_sent',
    slot: 'date_sent',
    sorter: (a, b) => moment(a.date_sent).diff(moment(b.date_sent)),
    width: 200
  }
];

export { NotificationHistoryColumn };
